<style lang="less" scoped>
	.editable {
		cursor: pointer;
	}
</style>

<template>
		<div>
			<codemirror v-model="element.text" :options="options" />
		</div>
		
</template>




<script type="text/javascript">
	import { codemirror } from 'vue-codemirror'
	import 'codemirror/lib/codemirror.css'
	import 'codemirror/theme/base16-dark.css'
	export default {
		name: "EditorHtml",
		props: {
			focus: {type: Object },
			element: {type: Object}
		},
		data: () =>{
			return {
				editing: false,
				options: {
					mode: 'text/html',
					theme: 'base16-dark',
				}
			}
		}, 
		components: {
			codemirror
		},
		watch:{
			focus: {
				immediate:true,
				handler(){
					if( this.focus == this.element ){
						this.editing = true
					}
					else{
						this.editing = false
					}
				}
			}
		}
	}
</script>

